import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { styles } = {}) => ({
  button: {
    display: 'flex',
    alignItems: 'center',
    ...styles,
  },
}));
